import { useNavigate, useLocation } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import { AccessAccount, CoupounDetails, CoupounList, get_contactus_list } from "../../../api/apiHandler";
import DataTable from "react-data-table-component";
import FontAwesome from "react-fontawesome";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { CButton, CFormInput, CInputGroup } from "@coreui/react";
import { Link } from "react-router-dom";
import customStyles from "../../../utils/dataTableStyles";
import { encryptURL } from "../../../api/apiClient";
import { TOAST_ERROR } from "../../../utils/common.service";
import { WEB_URL } from "../../../Config";
import moment from "moment";
import useDebounce from "../../../utils/useDebounce";
import FileModal from "../../../components/FileModal";

export default function FeedbackDetails({ isLoader }) {

    const [data, setData] = useState([])
    const navigate = useNavigate()
    const [search, setSearch] = useState('');
    const debounceSearch = useDebounce(search, 750);
    const location = useLocation()
    console.log('location.state: ', location.state);
    const feedbackId = location.state && location.state.feedback_detail.id;
    const feedback_detail = location.state && location.state.feedback_detail;

    const handleRedirect = (learnerId, learnerName ,userType, link) => {
        isLoader(true);
        AccessAccount({ user_id: learnerId })
            .then((response) => {
                if (response.code === "1") {
                    localStorage.setItem("PAtoken", response.data[0]?.token);
                    localStorage.setItem("MAisLogin", true);
                    localStorage.setItem("userType", userType);
                    localStorage.setItem("PAid", learnerId);
                    localStorage.setItem("MAname", learnerName);
                    localStorage.setItem("role", "admin");

                    isLoader(false);

                    // const url = `${WEB_URL}ewallet`;
                    window.open(link, '_blank');

                } else {
                    isLoader(false);
                    TOAST_ERROR("ERROR..!!");
                }
            })
            .catch((error) => {
                TOAST_ERROR("ERROR..!!");
            });
    };

    const handleBack = () => {
        navigate(-1);
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const openModal = (url) => {
        setSelectedFile(url);
        setShowModal(true);
    };

    const closeModal = () => {
        setSelectedFile(null);
        setShowModal(false);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <Link className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </Link>
                            <Link to="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </Link>
                        </div>
                    </div>
                </header>
                {/* <section className="main_sec"> */}
                    <div className="mx-5 mt-4">
                        <div>
                            <span onClick={handleBack} className="mx-4 mt-3 back-button">
                                <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313"></path>
                                </svg>
                                <span className="ms-2">Back</span>
                            </span>
                        </div>
                        <p className="ms-3 fs-4 fw-500 text-center mb-5">Feedback Details</p>
                        {isLoader && feedback_detail?.length !== 0 ? (
                            <div className="row d-flex justify-content-center align-items-center mb-5">
                                <div className="col col-lg-6 mb-4 mb-lg-0">
                                    <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                        <div className="row g-0">
                                            <div className="col-md-12">
                                                <div className="card-body p-4">
                                                    <h6 className="mb-2">Information</h6>
                                                    <hr className="mt-0 mb-4" />
                                                    <div className="row pt-1">
                                                        {feedback_detail.complainer_name && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Complainer Name</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.complainer_name}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.feedback_type && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Feedback Type</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.feedback_type}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.feedback_details && (
                                                            <div className="col-12 mb-3">
                                                                <p className="fw-600">Feedback Details</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.feedback_details}</p>
                                                            </div>
                                                        )}
                                                        {(feedback_detail.feedback_type && feedback_detail.feedback_type == "Other Reason") && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Feedback Reason</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.other_reason}</p>
                                                            </div>
                                                        )}
                                                        {(feedback_detail.attachments && feedback_detail.attachments.length > 0) && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Feedback Attachment</p>
                                                                    {feedback_detail.attachments.map((doc, index) => (
                                                                        <a
                                                                            key={doc.id}
                                                                            onClick={() => openModal(doc.attachments)}
                                                                            className="text-purple underline mt-1 d-block"
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            View Attachment {index + 1}
                                                                        </a>
                                                                    ))}
                                                            </div>
                                                        )}
                                                        {feedback_detail.class_link && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">View Classroom</p>
                                                                <a
                                                                    onClick={() => handleRedirect(feedback_detail?.user_id, feedback_detail?.complainer_name, feedback_detail?.user_category, feedback_detail?.class_link)}
                                                                    className="text-purple underline mt-1 d-block"
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Click Here
                                                                </a>
                                                                <p className="text-muted mt-2">{}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.class_name && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Activity Title</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.class_name}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.class_type && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Activity Type</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.class_type}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.time_of_class && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Activity Time</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.time_of_class}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.teacher_name && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Full Name</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.teacher_name}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.code_generate && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">User Code</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.code_generate}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.category && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Role</p>
                                                                <p className="text-muted mt-2">{feedback_detail?.category}</p>
                                                            </div>
                                                        )}
                                                        {feedback_detail.date && (
                                                            <div className="col-6 mb-3">
                                                                <p className="fw-600">Date</p>
                                                                <p className="text-muted mt-2">{moment(feedback_detail?.date).format("DD-MM-YYYY")}</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            null
                        )}
                    </div>
                {/* </section> */}
            </div>
        </main>

        {showModal && <FileModal isOpen={showModal} fileUrl={selectedFile} onClose={closeModal} />}
    </>
}